import React from 'react'
import PropTypes from 'prop-types'

import HobnobHud from 'components/common/HobnobHud'

import styles from './locked-event.scss'

export default class LockedEvent extends React.Component {
  _flyerUrl () {
    const { event } = this.props
    if (event && event.flyer) {
      return event.flyer.watermarked_url_2x
    } else {
      return ''
    }
  }

  render () {
    return <div>
      <div className={styles['flier-container']}>
        <img className={styles['flier']} src={this._flyerUrl()} />
      </div>
      <HobnobHud show message='This event is no longer active' type='error' onClose={() => {}} host={{}} />
    </div>
  }
}

LockedEvent.propTypes = {
  event: PropTypes.object
}
